import {
  HStack,
  NumberIncrementStepper,
  NumberDecrementStepper,
  NumberInput,
  NumberInputField,
  NumberInputStepper,
  Text,
} from "@chakra-ui/react";

interface Props {
  head?: string;
  tail?: string;
  width?: number;
  defaultValue?: string;
  step?: number;
  min?: number;
  onChange: (arg0: number) => void;
}
export default function ToolNumberInput({
  head,
  tail,
  width,
  defaultValue,
  step = 1,
  min,
  onChange,
}: Props) {
  return (
    <HStack pb={4}>
      {head && (
        <Text fontSize="lg" w={width} fontWeight={600}>
          {head}
        </Text>
      )}
      <NumberInput
        size="md"
        maxW={24}
        defaultValue={defaultValue}
        min={min}
        step={step}
        onChange={(value) => onChange(+value)}
      >
        <NumberInputField />
        <NumberInputStepper>
          <NumberIncrementStepper />
          <NumberDecrementStepper />
        </NumberInputStepper>
      </NumberInput>
      {tail && <Text fontSize="lg">{tail}</Text>}
    </HStack>
  );
}
